if (!customElements.get('faq-accordion')) {
  customElements.define(
    'faq-accordion',
    class FaqAccordion extends HTMLElement {
      connectedCallback() {
        this.detailsElements = Array.from(this.querySelectorAll('details'));
        this.detailsElements.forEach((details) => {
          details.addEventListener('toggle', this.onToggle.bind(this));
        });
      }

      onToggle(event) {
        if (!event.target.open) return;
        this.detailsElements.forEach((details) => {
          if (details !== event.target) details.removeAttribute('open');
        });
      }
    }
  );
}
